import React, { Fragment } from 'react'
import { Row, Col, Input, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTrashAlt, faTimes } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
import PermissionWrapper from '../../auth/PermissionWrapper';
import 'bootstrap/dist/css/bootstrap.css';

class ClientAccounts extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            editAccount: {},
            newAccount: {}
        };

        this.blankAccount = {
            id: 0,
            custodian: '',
            accountNumber: '',
            portfolioCode: '',
            notes: '',
            complete: ''
        }

    }

    onChange = (e, type) => {
        this.props.log('ClientAccounts.js/onChange (e, type)', e, type);
        e.persist();
        let thisAccount = (type === 'edit') ? this.state.editAccount : this.state.newAccount;
        switch (e.target.name) {
            case "complete":
                thisAccount[e.target.name] = !thisAccount[e.target.name];
                break;
            default:
                thisAccount[e.target.name] = e.target.value;
        }
        this.setState(() => {
            return (type === 'edit') ? { editAccount: thisAccount } : { newAccount: thisAccount };
        });
    }

    onEdit = (id) => {
        this.props.log('ClientAccounts.js/onEdit (id)', id);
        const account = [...this.props.report.accounts].filter(item => item.id === id)[0];
        this.setState(() => {
            return {
                editAccount: account
            }
        })
    }

    onDelete = (id) => {
        this.props.log('ClientAccounts.js/onDelete (id)', id);
        fetch('/api/clientAccounts/' + id, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.setState({
                        editAccount: { ...this.blankAccount },
                    }, () => this.props.getClientReports());
                    this.props.addToast('Client account deleted successfully.', 5, 'success')
                } else {
                    this.props.addToast('Unable to delete client account.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleCancel = () => {
        this.props.log('ClientAccounts.js/handleCancel');
        this.setState({
            editAccount: { ...this.blankAccount },
        })
    }

    handleEdit = () => {
        this.props.log('ClientAccounts.js/handleEdit');
        fetch('/api/clientAccounts/' + this.state.editAccount.id, {
            method: 'PUT',
            body: JSON.stringify({ ...this.state.editAccount, clientReportId: this.props.selectedClientReportId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    this.props.addToast('Client account updated successfully.', 5, 'success')
                    this.setState({
                        editAccount: { ...this.blankAccount }
                    }, () => this.props.getClientReports());
                } else {
                    this.props.addToast('Unable to update client account.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    handleAdd = (e) => {
        this.props.log('ClientAccounts.js/handleAdd (name, value, e)', e.target.name, e.target.value, e);
        fetch('/api/clientAccounts/', {
            method: 'POST',
            body: JSON.stringify({ ...this.state.newAccount, clientReportId: this.props.selectedClientReportId }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            }
        })
            .then(results => results.json())
            .then(results => {
                if (parseInt(results.data) > 0) {
                    this.setState({
                        newAccount: { ...this.blankAccount }
                    }, () => {
                        this.props.getClientReports();
                        this.props.addToast('Client account added successfully.', 5, 'success')
                    });
                } else {
                    this.props.addToast('Unable to add client account.', 5, 'danger')
                }
            })
            .catch(() => {
                this.props.addToast('An error has occurred.', 5, 'danger');
            })
    }

    standardRow = (account) => {
        this.props.info('ClientAccounts.js/standardRow (account)', account);
        return (
            <tr className='pointer' onClick={() => this.onEdit(account.id)}>
                <td>{account.custodian}</td>
                <td>{account.accountNumber}</td>
                <td>{account.portfolioCode}</td>
                <td>{account.notes}</td>
                <td>{account.complete ? 'Yes' : 'No'}</td>
                <td></td>
            </tr>
        )
    }

    editRow = (account) => {
        this.props.log('ClientAccounts.js/editRow (account)', account);
        return (
            <tr>
                <td>{this.state.editAccount.custodian}</td>
                <td>{this.state.editAccount.accountNumber}</td>
                <td>
                    <Input
                        type="text"
                        name="portfolioCode"
                        value={this.props.isFieldNull(this.state.editAccount.portfolioCode)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        type="textarea"
                        name="notes"
                        value={this.props.isFieldNull(this.state.editAccount.notes)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <Input
                        className='m-0'
                        type="checkbox"
                        name="complete"
                        checked={this.props.isFieldNull(this.state.editAccount.complete, true)}
                        onChange={e => this.onChange(e, 'edit')}
                    />
                </td>
                <td>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Edit Client Accounts">
                        <Button className="mx-1" color="success" onClick={this.handleEdit} title="Edit Account">
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </PermissionWrapper>
                    <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Delete Client Accounts">
                        <ConfirmButton className="mx-3" color="danger" onClick={() => this.onDelete(account.id)} title="Delete Account">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </ConfirmButton>
                    </PermissionWrapper>
                    <Button className="mx-1" color="secondary" onClick={this.handleCancel} title="Cancel">
                        <FontAwesomeIcon icon={faTimes} />
                    </Button>
                </td>
            </tr>
        )
    }

    addRow = () => {
        this.props.info('ClientAccounts.js/addRow');
        return (
            <tr>
                <td>
                    <Input
                        type="text"
                        name="custodian"
                        placeholder="New Custodian"
                        value={this.props.isFieldNull(this.state.newAccount.custodian)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="accountNumber"
                        placeholder="Account Number"
                        value={this.props.isFieldNull(this.state.newAccount.accountNumber)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="text"
                        name="portfolioCode"
                        placeholder='Portfolio Code'
                        value={this.props.isFieldNull(this.state.newAccount.portfolioCode)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        type="textarea"
                        name="notes"
                        placeholder='Notes'
                        value={this.props.isFieldNull(this.state.newAccount.notes)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Input
                        className='m-0'
                        type="checkbox"
                        name="complete"
                        checked={this.props.isFieldNull(this.state.newAccount.complete, true)}
                        onChange={e => this.onChange(e)}
                    />
                </td>
                <td>
                    <Button disabled={this.state.newAccount.custodian === '' || this.state.newAccount.custodian == null || this.state.newAccount.accountNumber === '' || this.state.newAccount.accountNumber == null} color="primary" onClick={this.handleAdd}>Add Account</Button>
                </td>
            </tr>
        )
    }

    render = () => {
        this.props.info('ClientAccounts.js/render');
        return (
            <Row>
                <Col md="12">
                    <table className="dataGrid">
                        <thead>
                            <tr>
                                <th className="py-2" colSpan={2}>Custodian Account Info</th>
                                <th className="py-2" colSpan={4}>Portfolio Management System Account Setup Info</th>
                            </tr>
                            <tr>
                                <th>Custodian</th>
                                <th>Account Number</th>
                                <th>Portfolio Code</th>
                                <th>Notes</th>
                                <th>Complete</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.report.accounts.map((account) => (
                                <Fragment key={account.id}>{this.state.editAccount.id === account.id ? this.editRow(account) : this.standardRow(account)}</Fragment>
                            ))}
                            <PermissionWrapper hidden={true} refreshUser={this.props.refreshUser} {...this.props} {...this.state} allowedPermission="Add Client Accounts">
                                {this.addRow()}
                            </PermissionWrapper>
                        </tbody>
                    </table>
                </Col>
            </Row>
        )
    }
}

export default ClientAccounts;